
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-6b9ypa",
"minContentWidth": "--awsui-min-content-width-6b9ypa",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-6b9ypa",
"contentGapLeft": "--awsui-content-gap-left-6b9ypa",
"contentGapRight": "--awsui-content-gap-right-6b9ypa",
"contentHeight": "--awsui-content-height-6b9ypa",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-6b9ypa",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-6b9ypa",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-6b9ypa",
"defaultMaxContentWidth": "--awsui-default-max-content-width-6b9ypa",
"defaultMinContentWidth": "--awsui-default-min-content-width-6b9ypa",
"drawerSize": "--awsui-drawer-size-6b9ypa",
"drawerMinSize": "--awsui-drawer-min-size-6b9ypa",
"bottomDrawerSize": "--awsui-bottom-drawer-size-6b9ypa",
"footerHeight": "--awsui-footer-height-6b9ypa",
"headerGap": "--awsui-header-gap-6b9ypa",
"headerHeight": "--awsui-header-height-6b9ypa",
"layoutWidth": "--awsui-layout-width-6b9ypa",
"mainGap": "--awsui-main-gap-6b9ypa",
"mainOffsetLeft": "--awsui-main-offset-left-6b9ypa",
"mainTemplateRows": "--awsui-main-template-rows-6b9ypa",
"mobileBarHeight": "--awsui-mobile-bar-height-6b9ypa",
"notificationsHeight": "--awsui-notifications-height-6b9ypa",
"offsetTop": "--awsui-offset-top-6b9ypa",
"overlapHeight": "--awsui-overlap-height-6b9ypa",
"navigationWidth": "--awsui-navigation-width-6b9ypa",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-6b9ypa",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-6b9ypa",
"splitPanelHeight": "--awsui-split-panel-height-6b9ypa",
"splitPanelMinWidth": "--awsui-split-panel-min-width-6b9ypa",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-6b9ypa",
"toolsMaxWidth": "--awsui-tools-max-width-6b9ypa",
"toolsWidth": "--awsui-tools-width-6b9ypa",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-6b9ypa",
"contentScrollMargin": "--awsui-content-scroll-margin-6b9ypa",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-6b9ypa",
"flashbarStackIndex": "--awsui-flashbar-stack-index-6b9ypa",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-6b9ypa",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-6b9ypa",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-6b9ypa",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-6b9ypa",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-6b9ypa",
"dropdownContentBorderColor": "--awsui-dropdown-content-border-color-6b9ypa",
"dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-6b9ypa",
"dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-6b9ypa",
"modalCustomWidth": "--awsui-modal-custom-width-6b9ypa",
"modalCustomHeight": "--awsui-modal-custom-height-6b9ypa",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-6b9ypa",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-6b9ypa",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-6b9ypa",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-6b9ypa",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-6b9ypa",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-6b9ypa",
"sliderLabelCount": "--awsui-slider-label-count-6b9ypa",
"sliderTickCount": "--awsui-slider-tick-count-6b9ypa",
"sliderReferenceColumn": "--awsui-slider-reference-column-6b9ypa",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-6b9ypa",
"sliderMaxStart": "--awsui-slider-max-start-6b9ypa",
"sliderMinEnd": "--awsui-slider-min-end-6b9ypa",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-6b9ypa",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-6b9ypa",
"togglesLeftWidth": "--awsui-toggles-left-width-6b9ypa",
"togglesRightWidth": "--awsui-toggles-right-width-6b9ypa",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-6b9ypa",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-6b9ypa",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-6b9ypa",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-6b9ypa",
"styleBackgroundActive": "--awsui-style-background-active-6b9ypa",
"styleBackgroundDefault": "--awsui-style-background-default-6b9ypa",
"styleBackgroundDisabled": "--awsui-style-background-disabled-6b9ypa",
"styleBackgroundHover": "--awsui-style-background-hover-6b9ypa",
"styleBorderColorActive": "--awsui-style-border-color-active-6b9ypa",
"styleBorderColorDefault": "--awsui-style-border-color-default-6b9ypa",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-6b9ypa",
"styleBorderColorHover": "--awsui-style-border-color-hover-6b9ypa",
"styleColorActive": "--awsui-style-color-active-6b9ypa",
"styleColorDefault": "--awsui-style-color-default-6b9ypa",
"styleColorDisabled": "--awsui-style-color-disabled-6b9ypa",
"styleColorHover": "--awsui-style-color-hover-6b9ypa",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-6b9ypa",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-6b9ypa",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-6b9ypa",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-6b9ypa",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-6b9ypa",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-6b9ypa",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-6b9ypa",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-6b9ypa",
"styleBackgroundReadonly": "--awsui-style-background-readonly-6b9ypa",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-6b9ypa",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-6b9ypa",
"styleColorReadonly": "--awsui-style-color-readonly-6b9ypa",
"styleBackgroundFocus": "--awsui-style-background-focus-6b9ypa",
"styleBorderColorFocus": "--awsui-style-border-color-focus-6b9ypa",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-6b9ypa",
"styleColorFocus": "--awsui-style-color-focus-6b9ypa",
"stylePlaceholderColor": "--awsui-style-placeholder-color-6b9ypa",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-6b9ypa",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-6b9ypa",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-6b9ypa",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-6b9ypa",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-6b9ypa",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-6b9ypa",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-6b9ypa",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-6b9ypa",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-6b9ypa",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-6b9ypa",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-6b9ypa",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-6b9ypa",
"alertIconColor": "--awsui-alert-icon-color-6b9ypa",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-6b9ypa",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-6b9ypa",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-6b9ypa",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-6b9ypa",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-6b9ypa",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-6b9ypa",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-6b9ypa",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-6b9ypa",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-6b9ypa",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-6b9ypa",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-6b9ypa",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-6b9ypa",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-6b9ypa",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-6b9ypa",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-6b9ypa",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-6b9ypa",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-6b9ypa",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-6b9ypa",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-6b9ypa",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-6b9ypa",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-6b9ypa",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-6b9ypa",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-6b9ypa",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-6b9ypa",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-6b9ypa",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-6b9ypa",
"progressBarHeight": "--awsui-progress-bar-height-6b9ypa",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-6b9ypa",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-6b9ypa",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-6b9ypa",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-6b9ypa",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-6b9ypa",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-6b9ypa",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-6b9ypa",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-6b9ypa",
"tokenStyleBackgroundDefault": "--awsui-token-style-background-default-6b9ypa",
"tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-6b9ypa",
"tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-6b9ypa",
"tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-6b9ypa",
"tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-6b9ypa",
"tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-6b9ypa",
"tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-6b9ypa",
"tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-6b9ypa",
"tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-6b9ypa",
"tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-6b9ypa",
"styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-6b9ypa",
"styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-6b9ypa",
"styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-6b9ypa",
"styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-6b9ypa",
"styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-6b9ypa",
      };
      export default customCSSPropertiesMap;
    


// WEBPACK FOOTER //
// /local/home/vibhorbh/src/internal/generated/custom-css-properties/index.ts